/* eslint-disable no-param-reassign */
import PropTypes from "prop-types";
import { extractData } from "../utils";

const Input = ({ children, ...componentProps }) => {
  const Component = componentProps.selectProps?.custom?.Input;

  if (!Component) {
    return null;
  }

  return (
    <Component componentProps={componentProps} data={extractData(componentProps)}>
      {children}
    </Component>
  );
};

Input.propTypes = {
  selectProps: PropTypes.shape({
    custom: PropTypes.shape({
      Input: PropTypes.func,
    }),
  }),
  children: PropTypes.node,
};

Input.defaultProps = {
  selectProps: {
    custom: {
      Input: null,
    },
  },
  children: null,
};

export default Input;
